import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import cellEditFactory from "react-bootstrap-table2-editor";
import * as action from "../../../../../redux/actions/index";
import Table from "../../Components/Table";
import { Type } from "react-bootstrap-table2-editor";
import * as requestFromServer from "../../../../network/api";
import Modal from "../../Components/SettingModal";
import { useTranslation } from "react-i18next";
import {
  makeStyles,
  TextField,
  IconButton,
  Button,
  fade,
} from "@material-ui/core";
import moment from "moment";
export function CategoryTable() {
  const { t } = useTranslation(["setting"]);
  const dispatch = useDispatch();
  const [showModal, setshowModal] = useState(false);
  const [changedData, SetChangedData] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, sizePerPage: 10 });

  const dateFormatter = (cell, row) => {
    if (cell) {
      var a = new Date(cell);
      return `${a.getUTCFullYear()}/${a.getUTCMonth()}/${a.getUTCDate()}`;
    }
    return cell;
  };

  // Col-----------------------------------------------------------------------------------------------
  const statusButtons = (status) => {
    if (status === "Active") {
      return (
        <Button variant="outlined" color="primary" size="small">
          {t("setting:settings.Active")}
        </Button>
      );
    } else {
      return (
        <Button variant="outlined" color="secondary" size="small">
          {t("setting:settings.InActive")}
        </Button>
      );
    }
  };

  const columns = [
    {
      dataField: "_id",
      text: "ID",
      editable: false,
      hidden: true,
    },
    {
      dataField: "name",
      // Category Name - カテゴリー名
      text: `${t("setting:category.categoryName")}`,
      editable: true,
      headerAlign: "center",
      align: "center",
      style: {
        "font-size": "12px",
        fontWeight: "normal",
      },
    },
    {
      dataField: "createdAt",
      // Created On - 作成日
      text: `${t("setting:category.createdDate")}`,
      editable: false,
      formatter: (cell, row) => {
        if (cell) {
          return moment(cell).format("YYYY-MM-DD");
        }
      },
      headerAlign: "center",
      align: "center",
      sort: true,
      style: {
        "font-size": "12px",
        fontWeight: "normal",
      },
    },
    {
      dataField: "activeStatus",
      // Status - ステータス
      text: `${t("setting:category.status")}`,
      sort: true,
      headerAlign: "center",
      align: "center",
      style: {
        "font-size": "12px",
        fontWeight: "normal",
      },
      formatter: (cell) =>
        cell ? statusButtons("Active") : statusButtons("InActive"),

      editor: {
        type: Type.SELECT,
        getOptions: (setOptions, { row, column }) => {
          return [
            {
              value: "true",
              label: `${t("setting:settings.Active")}`,
            },
            {
              value: "false",
              label: `${t("setting:settings.InActive")}`,
            },
          ];
        },
      },
    },
  ];
  // -----------------------------------------------------------------------------------------------------
  const { currentState } = useSelector(
    (state) => ({ currentState: state.category }),
    shallowEqual
  );

  const { category, totalCount } = currentState;

  const [state, setState] = useState({
    page: 1,
    data: category,
    totalSize: totalCount,
    sizePerPage: 10,
  });

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, cellEdit }
  ) => {
    requestFromServer.fetchCategory(page, sizePerPage).then((res) => {
      setPagination((prevState) => {
        return {
          ...prevState,
          page: page,
          sizePerPage: sizePerPage,
        };
      });
      let DataArray = [];
      res.data["data"].map((item) => DataArray.push(item));

      dispatch(action.createCategory(DataArray));

      setState((prevState) => {
        return {
          ...prevState,
          page: page,
          data: DataArray,
          totalSize: totalCount,
          sizePerPage: sizePerPage,
        };
      });
    });

    if (sortField) {
      requestFromServer
        .sortCategory(sortField, sortOrder, sizePerPage, page)
        .then((res) => {
          setPagination((prevState) => {
            return {
              ...prevState,
              page: page,
              sizePerPage: sizePerPage,
            };
          });
          let DataArray = [];
          res.data["data"].map((item) => DataArray.push(item));

          dispatch(action.createCategory(DataArray));

          setState((prevState) => {
            return {
              ...prevState,
              page: page,
              data: DataArray,
              totalSize: totalCount,
              sizePerPage: sizePerPage,
            };
          });
        });
    }
  };

  useEffect(() => {
    setState((prevState) => {
      return {
        ...prevState,
        page: pagination.page,
        data: category,
        totalSize: totalCount,
        sizePerPage: pagination.sizePerPage,
      };
    });
  }, [category, totalCount, pagination.page, pagination.sizePerPage]);

  const getSearchResult = (query) => {
    //Need to make api call to database and set State here
    //TODO: Query Database and set result to State

    requestFromServer
      .searchCategory(query)
      .then((res) => {
        setState((prevState) => {
          return {
            ...prevState,
            page: res.data["data"].slice(0, 10),
            data: res.data["data"],
            totalSize: 1,
            sizePerPage: res.data["totalcount"],
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const savecell = (oldValue, newValue, row, column) => {
    if (oldValue !== newValue) {
      setshowModal(true);
      SetChangedData({ oldValue, newValue, row, column });
    }
  };

  const hideModal = () => {
    console.log("hideModal");
    setshowModal(false);
  };
  const onSubmit = () => {
    console.log("onSubmit");
    setshowModal(false);
    if (changedData) {
      const oldValue = changedData["oldValue"];
      const newValue = changedData["newValue"];
      const row = changedData["row"];
      const column = changedData["column"];

      if (typeof oldValue !== "boolean") {
        requestFromServer
          .updateCategoryPut(row._id, newValue, row.activeStatus)
          .then((res) => {
            const MappedArray = category.map(function(item) {
              return item._id == res.data["data"]._id ? res.data["data"] : item;
            });
            setState((prevState) => {
              return {
                ...prevState,
                data: MappedArray,
              };
            });
          });
      } else {
        let Bool = newValue;
        Bool === "false" ? (Bool = false) : (Bool = true);
        requestFromServer
          .updateCategoryPut(row._id, row.name, Bool)
          .then((res) => {
            const MappedArray = category.map(function(item) {
              return item._id == res.data["data"]._id ? res.data["data"] : item;
            });

            setState((prevState) => {
              return {
                ...prevState,
                data: MappedArray,
              };
            });
          });
      }
    }
  };
  return (
    <>
      <Modal
        showModal={showModal}
        hideModal={hideModal}
        onSubmit={onSubmit}
        field={"Category"}
      />
      <Table
        columns={columns}
        handleTableChange={handleTableChange}
        getSearchResult={getSearchResult}
        state={state}
        saveCell={savecell}
      />
    </>
  );
}
